import { useRef, useState } from "react"
import { getUser, setUser, useHub } from "../../../core/Global"
import { Drawer, DrawerRef } from "../../../components/drawers/Drawer"
import Form from "../../../components/form/Form"
import Icon from "../../../components/base/Icon"
import DropDown from "../../../components/form/DropDown"
import { API_ROUTES } from "../../../core/Constants"
import TextBox from "../../../components/form/TextBox"



interface IProps {
    onClose: () => void
}
export default function AccountUsernameMobile(props: IProps) {

    const hub = useHub()
    const drawer = useRef<DrawerRef>(null)
    const user = getUser()
    const [working, workingSet] = useState<boolean>(false)

    return (
        <Drawer ref={drawer} title="Username"
            onClose={props.onClose}>
            <Form id="user-edit-form-mobile" className="form"
                onSubmit={(body, callback) => {

                    if (window.isNullOrEmpty(body.username)) {
                        window.formError("username", "Please write your new username!", "user-edit-form-mobile", true);
                        return;
                    }
                    if (window.isNullOrEmpty(body.password)) {
                        window.formError("password", "Please write your current password!", "user-edit-form-mobile", true);
                        return;
                    }
                    workingSet(true);


                    hub.Put("/accounts/profile/username", body, res => {

                        if (res.success && res.data) {
                            setUser(res.data)
                            drawer.current?.close()
                        }

                        workingSet(false)
                    })

                }}>


                <TextBox label="Current Username" value={user?.username} block labelUp />

                <TextBox label="New Username" name="username" block labelUp />

                <TextBox label="Confirm Password" name="password" password block labelUp />



                <button type="submit" className="btn btn-primary w-100 mb-3 mt-5">
                    {
                        working ?
                            <>
                                <Icon icon="spinner-third" spin />
                                <span className="ms-2">Updating...</span>
                            </>
                            :
                            <>Update Username</>
                    }
                </button>

                <button type="button" className="btn btn-secondary w-100 mb-10"
                    onClick={e => drawer.current?.close()}>
                    Discard
                </button>

            </Form>
        </Drawer>
    )

}